import styled from 'styled-components'
import { FlexBox, MEDIA } from '@brg/ui'
import { LayoutConst } from 'core'

export const Wrapper = styled(FlexBox)`
    width: 100%;
    max-width: 1152px;
    max-height: calc(100vh - 96px);
    background: #FEFEFE;
    border-radius: 4px;
    padding: 40px 0px;
    flex-flow: column;
    gap: 32px;
    overflow: hidden;

    @media ${MEDIA.TABLET} {
        max-width: 712px;
    }

    @media (max-width: ${LayoutConst.screen.m}px) {
        width: calc(100vw - 32px);
        max-height: calc(100vh - 32px);
        padding: 32px 0 24px;
        gap: 24px;
    }
`

export const Title = styled.div`
    font-family: Inter, sans-serif;
    font-weight: 600;
    font-size: 30px;
    line-height: 40px;
    letter-spacing: -0.6px;
    color: #151514;
    text-align: center;
    padding-right: 48px;
    padding-left: 48px;

    @media (max-width: ${LayoutConst.screen.m}px) {
        font-size: 22px;
        line-height: 28px;
        padding-right: 40px;
        padding-left: 0;
    }
`

export const SearchRow = styled.div`
    display: flex;
    align-items: center;
    gap: 16px;
    width: 100%;

    @media (max-width: ${LayoutConst.screen.m}px) {
        gap: 8px;
    }
`

export const SearchBox = styled.div`
    position: relative;
    flex: 1;
    display: flex;
    align-items: center;
    height: 46px;
    background: #F4F4F4;
    border-radius: 4px;
    padding: 0 16px;
    gap: 12px;
`

export const SearchInputEl = styled.input`
    flex: 1;
    border: none;
    outline: none;
    background: transparent;
    font-family: Inter, sans-serif;
    font-size: 15px;
    line-height: 20px;
    letter-spacing: -0.3px;
    color: #151514;

    &::placeholder {
        color: #70706F;
    }
`

export const ClearButton = styled.button`
    background: transparent;
    border: none;
    cursor: pointer;
    padding: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #70706F;

    &:hover {
        color: #151514;
    }
`

export const FindButton = styled.button`
    height: 46px;
    padding: 0 40px;
    background: #151514;
    color: #FEFEFE;
    border: none;
    border-radius: 4px;
    font-family: Inter, sans-serif;
    font-size: 15px;
    font-weight: 600;
    line-height: 20px;
    letter-spacing: -0.3px;
    cursor: pointer;
    flex-shrink: 0;

    &:hover {
        background: #000;
    }
`

export const ScrollArea = styled.div`
    flex: 1;
    overflow-y: auto;
    padding-right: 4px;

    &::-webkit-scrollbar {
        width: 6px;
    }
    &::-webkit-scrollbar-track {
        background: transparent;
    }
    &::-webkit-scrollbar-thumb {
        border-radius: 3px;
        background: #D9D9D9;
    }
`

export const EmptyState = styled.div`
    padding: 48px 0;
    text-align: center;
    font-family: Inter, sans-serif;
    font-size: 15px;
    color: #70706F;
`

export const FooterRow = styled.div`
    display: flex;
    justify-content: flex-end;
    gap: 12px;
    padding-top: 8px;
    border-top: 1px solid #E7E7E7;
`

export const Grid = styled.div`
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 24px;
    width: 100%;

    .dct {
        font-weight: 600;
        color: #151514;
    }

    @media ${MEDIA.LAPTOP} {
        gap: 16px;
    }

    @media (max-width: ${LayoutConst.screen.s - 1}px) {
        grid-template-columns: repeat(2, 1fr);
        gap: 16px;
    }
`

import styled from 'styled-components'
import { FlexBox, MEDIA } from '@brg/ui'
import { LayoutConst } from 'core'

export const Wrapper = styled(FlexBox)`
    width: 100%;
    max-width: 1152px;
    max-height: calc(100vh - 96px);
    background: #FEFEFE;
    border-radius: 4px;
    padding: 40px 0px;
    flex-flow: column;
    gap: 32px;
    overflow: hidden;

    @media ${MEDIA.TABLET} {
        max-width: 712px;
    }

    @media (max-width: ${LayoutConst.screen.m}px) {
        width: calc(100vw - 32px);
        max-height: calc(100vh - 32px);
        padding: 32px 0 24px;
        gap: 24px;
    }
`

export const Title = styled.div`
    font-family: Inter, sans-serif;
    font-weight: 600;
    font-size: 30px;
    line-height: 40px;
    letter-spacing: -0.6px;
    color: #151514;
    text-align: center;
    padding-right: 48px;
    padding-left: 48px;

    @media (max-width: ${LayoutConst.screen.m}px) {
        font-size: 22px;
        line-height: 28px;
        padding-right: 40px;
        padding-left: 0;
    }
`

export const SearchRow = styled.div`
    display: flex;
    align-items: center;
    gap: 16px;
    width: 100%;

    @media (max-width: ${LayoutConst.screen.m}px) {
        gap: 8px;
    }
`

export const SearchBox = styled.div`
    position: relative;
    flex: 1;
    display: flex;
    align-items: center;
    height: 46px;
    background: #F4F4F4;
    border-radius: 4px;
    padding: 0 16px;
    gap: 12px;
`

export const SearchInputEl = styled.input`
    flex: 1;
    border: none;
    outline: none;
    background: transparent;
    font-family: Inter, sans-serif;
    font-size: 15px;
    line-height: 20px;
    letter-spacing: -0.3px;
    color: #151514;

    &::placeholder {
        color: #70706F;
    }
`

export const ClearButton = styled.button`
    background: transparent;
    border: none;
    cursor: pointer;
    padding: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #70706F;

    &:hover {
        color: #151514;
    }
`

export const FindButton = styled.button`
    height: 46px;
    padding: 0 40px;
    background: #151514;
    color: #FEFEFE;
    border: none;
    border-radius: 4px;
    font-family: Inter, sans-serif;
    font-size: 15px;
    font-weight: 600;
    line-height: 20px;
    letter-spacing: -0.3px;
    cursor: pointer;
    flex-shrink: 0;

    &:hover {
        background: #000;
    }
`

export const ScrollArea = styled.div`
    flex: 1;
    overflow-y: auto;
    padding-right: 4px;

    &::-webkit-scrollbar {
        width: 6px;
    }
    &::-webkit-scrollbar-track {
        background: transparent;
    }
    &::-webkit-scrollbar-thumb {
        border-radius: 3px;
        background: #D9D9D9;
    }
`

export const EmptyState = styled.div`
    padding: 48px 0;
    text-align: center;
    font-family: Inter, sans-serif;
    font-size: 15px;
    color: #70706F;
`

export const FooterRow = styled.div`
    display: flex;
    justify-content: flex-end;
    gap: 12px;
    padding-top: 8px;
    border-top: 1px solid #E7E7E7;
`

export const Grid = styled.div`
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 24px;
    width: 100%;

    .dct {
        font-weight: 600;
        color: #151514;
    }

    @media ${MEDIA.LAPTOP} {
        gap: 16px;
    }

    @media (max-width: ${LayoutConst.screen.s - 1}px) {
        grid-template-columns: repeat(2, 1fr);
        gap: 16px;
    }
`

